function uniqid() {
    var n = Math.floor(Math.random() * 11);
    var k = Math.floor(Math.random() * 1000000);
    var m = String.fromCharCode(n) + k;
    return m;
}

function scrollToStart(id) {
  var element = document.getElementById(id);
  var headerOffset = 100;
  var elementPosition = element.offsetTop;
  var offsetPosition = elementPosition - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}


/**
 * conta i prodotti nel carrello (prodotto x quantità)
 */
function countItemsInCart() {
    $.get( url_cart_countItems, {
        time: Date.now()
    }, function( count ) {
        $(".js-cart-counter").text(count);
    });
}

/* **************************************************
 * On page loaded
 */
$(function () {
    $("form.add-to-cart-form").find("button").removeClass("disabled");
    $("button.remove-from-cart").removeClass("disabled");

    countItemsInCart();
});
